import styles from './workspace-list.module.scss';
import { formatPicture } from '../../../core/services/image.service';
import { updateCurrentUserAvatar } from '../../../features/user/user.slice';
import { catchError } from '../../../core/catch-error';
import { useAuth } from '../../../workos-auth';

export const UserProfile = () => {
  const { user } = useAuth();

  const handleProfilePhoto = async (file?: File) => {
    if (!file) {
      return;
    }

    const options = { width: 250, height: 250 };
    const frame = await formatPicture(file, options);
    updateCurrentUserAvatar({ file: frame }).catch((e) => {
      catchError(e);
    });
  };

  return (
    <div className={styles['list']}>
      <div className={styles['item']}>
        <div className="column">
          {user.firstName} {user.lastName}
        </div>
      </div>
    </div>
  );
}
